import { render, staticRenderFns } from "./SeatidesView.vue?vue&type=template&id=73a774ec&"
import script from "./SeatidesView.vue?vue&type=script&lang=js&"
export * from "./SeatidesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports